import { React, useMemo } from "react";
import Image from "next/image";
import Slider from "react-slick";
import { useRouter } from "next/router";
import bakcell from "@/images/partners/bakcell.png";
import norm from "@/images/partners/norm.png";
import azertelecom from "@/images/partners/azertelecom.png";
import azerconnect from "@/images/partners/azerconnect.png";
import apar from "@/images/partners/apar.png";
import aztu from "@/images/partners/AzTU.png";
import devers from "@/images/partners/devers.png";
import galegait from "@/images/partners/galegait.png";
// import libraff from "@/images/partners/libraff.png";
import newtech from "@/images/partners/newtech.png";
import nobelenergy from "@/images/partners/nobelenergy.png";
import tehsilinkisaf from "@/images/partners/tehsilinkisaf.png";
import qwasar from "@/images/partners/qwasar.png";
import neqsol from "@/images/partners/neqsol.png";
import { useTranslation } from "next-i18next";

const Partners = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const isProgramsPage = router.pathname === "/programs";

  const sponsors = [
    { name: "Tehsilinkisaf", logo: tehsilinkisaf },
    { name: "NEQSOL Academy", logo: neqsol },
    { name: "Qwasar", logo: qwasar },
    { name: "AzTU", logo: aztu },
    { name: "Apar", logo: apar },
    { name: "NewTech", logo: newtech },
    // { name: "Libraff", logo: libraff },
    { name: "Galegait", logo: galegait },
  ];
  
  const partners = [
    { name: "Bakcell", logo: bakcell },
    { name: "Nobel Energy", logo: nobelenergy },
    { name: "Norm", logo: norm },
    { name: "Azerconnect", logo: azerconnect },
    { name: "AzerTelecom", logo: azertelecom },
    { name: "Devers", logo: devers },
  ];

  const allLogos = useMemo(() => [...sponsors, ...partners], []);
  const duplicatedAllLogos = useMemo(() => [...allLogos, ...allLogos], []);

  const sliderSettings = {
    centerMode: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 2000,
  };

  const renderList = () => (
    <Slider {...sliderSettings} className="partners-slider">
      {duplicatedAllLogos.map((p, i) => (
        <div key={i} className="px-2 md:px-4">
          <div className="!w-[200px] md:!w-[230px] h-[56px] md:h-[80px] bg-white rounded-full flex items-center justify-center cursor-pointer hover:opacity-60 transition-all duration-300">
            <div className="flex items-center gap-[10px] md:gap-[15px] justify-center w-full h-full px-2 py-2">
              <Image src={p.logo} alt={p.name} width={130} height={50} loading="lazy" className="object-contain max-w-full max-h-full" />
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );

  if (isProgramsPage) {
    return (
      <section className="py-[40px] md:py-[60px]">
        <div>
          <h2 className="text-[32px] md:text-[48px] font-[500] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884] mb-[32px] md:mb-[40px] text-center">
            {t("partners-tab-partners")}
          </h2>
        </div>
        <div className="max-w-[90%] mx-auto rounded-[24px] md:rounded-[32px] ">
          <div className="relative">{renderList()}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-[80px] md:py-[100px] rounded-t-[24px] md:rounded-t-[52px] bg-[#F5F5F5]">
      <div className="max-w-[90%] mx-auto rounded-[24px] md:rounded-[32px] ">
        <div className="relative">{renderList()}</div>
      </div>
    </section>
  );
};

export default Partners;
